function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    id: "id_101",
    style: {
      fill: "rgb(239, 68, 68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,5.6L17,7.1c1.3,1.3,2,3.1,2,4.9s-0.7,3.6-2.1,5l1.4,1.4c1.7-1.7,2.6-4,2.6-6.4S20.1,7.3,18.4,5.6z",
    id: "id_102",
    style: {
      fill: "rgb(239, 68, 68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,7L5.6,5.6C3.9,7.3,3,9.6,3,12c0,2.4,0.9,4.7,2.6,6.4L7,16.9c-1.3-1.3-2-3.1-2-4.9S5.7,8.4,7.1,7z",
    id: "id_103",
    style: {
      fill: "rgb(239, 68, 68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8.5l-1.4,1.4c0.6,0.6,0.9,1.3,0.9,2.1c0,0.8-0.3,1.5-0.9,2.1l1.4,1.4c1-1,1.5-2.2,1.5-3.5S16.5,9.4,15.5,8.5z",
    id: "id_104",
    style: {
      fill: "rgb(239, 68, 68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.5C7.5,9.4,7,10.6,7,12c0,1.4,0.5,2.6,1.5,3.5l1.4-1.4C9.3,13.5,9,12.8,9,12c0-0.8,0.3-1.5,0.9-2.1L8.5,8.5z",
    id: "id_105",
    style: {
      fill: "rgb(239, 68, 68)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.cc1ce8e9000257a62499354ee587257d.svg";
export { ForwardRef as ReactComponent };